@use '../../../../../styles/Constants.scss' as Constants;
@use '../../../../../styles/Colors.scss' as Colors;

.container {
	background-color: Colors.$col-greyLight;
	padding: Constants.$val-spacing-s;
}

.section {
	background-color: Colors.$col-white;
	margin-bottom: Constants.$val-spacing-s;
	padding: Constants.$val-spacing-m Constants.$val-spacing-s;
	border-bottom: 1px solid Colors.$col-greyConnection;
}

.index-cell {
	text-align: left;
	color: Colors.$col-design-grey500;
	padding: Constants.$val-spacing-xs;
	padding-top: Constants.$val-spacing-s;
	width: -webkit-fill-available;
	background-color: Colors.$col-white;
	font-size: Constants.$val-fontSizeBig;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	height: 100%;

	&__warning {
		color: Colors.$col-canceledRed;
	}
}

.dropdown-cell {
	font-size: Constants.$val-fontSizeBig;
	color: Colors.$col-design-grey500;
	width: -webkit-fill-available;
}

.checkbox-cell {
	width: -webkit-fill-available;
	background-color: Colors.$col-white;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
}

.data-sources-cell {
	width: -webkit-fill-available;
	background-color: Colors.$col-white;
	display: flex;
	flex-direction: row;
	justify-content: left;
	align-items: center;
	gap: Constants.$val-spacing-s;
	padding-left: Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeBig;
	color: Colors.$col-design-grey500;
	height: 100%;

	&__button {
		color: Colors.$col-design-blue500;

		&:hover {
			color: Colors.$col-design-blue500;
			cursor: pointer;
		}
	}
}

.data-sources-card {
	border: 1px solid Colors.$col-design-blue600;
	border-radius: Constants.$val-spacing-xs;
	background-color: Colors.$col-design-blue100;
	color: Colors.$col-design-blue600;
	font-size: Constants.$val-fontSizeRegular;
	padding: Constants.$val-spacing-xxs Constants.$val-spacing-s;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: Constants.$val-spacing-s;

	&__count {
		padding-left: Constants.$val-spacing-s;
		background-color: Colors.$col-design-blue600;
		border-radius: Constants.$val-spacing-l;
		color: Colors.$col-white;
		padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
	}
}

.section-header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeBig;
	color: Colors.$col-design-grey10;
	margin-bottom: Constants.$val-spacing-s;

	&__button {
		color: Colors.$col-design-blue500;
		text-transform: none;

		&:hover {
			color: Colors.$col-design-blue500;
			cursor: pointer;
		}
	}

	&--actions {
		display: flex;
		flex-direction: row;
		gap: Constants.$val-spacing-s;
	}
}

.title {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeXBig;
	font-weight: bold;
}

.buttons-container {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
	justify-content: end;
}

.preview-cell {
	display: flex;
	justify-content: center;
	align-items: center;
	color: Colors.$col-design-grey500;
	font-size: Constants.$val-fontSizeRegular;
}

.tooltip-header {
	margin-left: Constants.$val-spacing-s;
}

.input-cell {
	font-size: Constants.$val-fontSizeRegular !important;
}

.info-margin {
	margin-bottom: Constants.$val-spacing-m;
}